import { atom } from "jotai";

export const commentsAtom = atom([]);
export const activeCommentIdAtom = atom("");
export const commentUsersAtom = atom([]);
